import { sanitizeKey, sanitizeValue } from 'lib/gptSanitizeString';

const sanitizeValueIncDash = value => sanitizeValue(value, true);
const toLowerCase = value => String(value).toLowerCase();
const split = separator => value => value.split(separator);
const truthy = (value) => !!value;

/**
 * Applies a transform to an array of values
 */
export const mapTransform = transform =>
  values => (Array.isArray(values) ? values.map(transform) : null);

export const transforms = {
  sanitizeValue,
  sanitizeValueIncDash,
  toLowerCase,
  split,
  mapTransform,
  truthy,
};

/**
 * Resolves a value from either a function or a object of key/values
 */
export const resolveValue = (key, source) => {
  if (typeof source === 'function') return source(key);
  if (typeof source === 'object') return source[key];
  return '';
};

/**
 * Takes a key/value array and remaps it
 * @param {Array} keyValueMap - Array of targeting key/values to process from source
 * @param {Object|Function} source - An object of key/values or a function to use as a source for
 * generating a targeting list
 * @return {Object}
 * @example
 * [ { key: 'type', mappedKey: 'pagetype', transform: [toLowerCase, sanitizeValueIncDash] } ]
 * @example
 * [ 'pagetype' ]
 */
export default function mapKeyValues(keyValueMap, source, defaultTransforms = []) {
  const keyValues = {};

  keyValueMap.forEach((entry) => {
    const {
      key,
      mappedKey,
      transform,
      shouldSanitizeKey = true,
    } = (typeof entry === 'object') ? entry : { key: entry };

    const value = resolveValue(key, source);

    let targetKey = mappedKey || key;
    if (shouldSanitizeKey) targetKey = sanitizeKey(targetKey);

    const transformFns = Array.isArray(transform) ? transform : defaultTransforms;

    const transformedValue = transformFns
      .reduce((prev, fn) => (typeof fn === 'function' ? fn(prev, keyValues) : prev), value);

    keyValues[targetKey] = transformedValue;
  });

  return keyValues;
}
